import * as apiFactory from "./ApiFactory";
import { Api } from "./Api";

import type { RecordEvidenceCount } from "@/models/RecordEvidenceCount";

export async function getAll(clientName: string, brand: string, caseReference: string): Promise<RecordEvidenceCount[]> {
  const client: Api = await apiFactory.FeatuerWithBearer();
  return await client.getWithPollingSignal<RecordEvidenceCount[]>([
    "api/recordevidencecount",
    clientName,
    brand,
    caseReference,
  ]);
}

export async function getAllLabels(
  clientName: string,
  brand: string,
  ruleScope: "record" | "instance",
): Promise<string[]> {
  const client: Api = await apiFactory.FeatuerWithBearer();
  return await client.get<string[]>(["api/brandevidencecount/labels", clientName, brand, ruleScope]);
}
